const AspectRatio = {
  bind (el, binding) {
    let props = binding.expression
    if (props) {
      el.style.aspectRatio = props
    }
  }
}

export default AspectRatio



// WEBPACK FOOTER //
// ./src/bcq-ui/directives/aspect-ratio.js